import { GenderEnum } from '@msc-b2c/interfaces/enums';
import { GetContactInformationMyMSCResponse } from '@msc-b2c/interfaces/interfaces';

export const getContactInformationMyMSCResponseMock: GetContactInformationMyMSCResponse = {
  name: 'GARRETZENOTEST',
  surname: 'DOOLEYZENOTEST',
  dateOfBirth: '2001-08-05',
  gender: GenderEnum.FEMALE,
  email: 'abcd@gmail.com.au',
  phone: '+341234567890',
  mobilePhone: '+3412345677',
  address: {
    addressLine1: 'TEST ADDRESS',
    town: 'DARLINGTON',
    districtName: 'VIERA',
    region: 'CAMPANIA',
    province: 'RM',
    state: 'GBR',
    postCode: '28001',
    country: 'ITALY',
  },
  marketingConsents: {
    phone: true,
    mobilePhone: true,
    email: true,
  },
  thirdPartyConsent: false,
  profilingConsent: false,
};
